export function convertValue(value, fromUnit, toUnit) {
  if (!Number.isFinite(value)) return Number.NaN

  const baseValue = fromUnit.conversion === 'reciprocal'
    ? value === 0 ? Number.POSITIVE_INFINITY : fromUnit.constant / value
    : value * fromUnit.factor + (fromUnit.offset ?? 0)

  if (toUnit.conversion === 'reciprocal') {
    return baseValue === 0 ? Number.POSITIVE_INFINITY : toUnit.constant / baseValue
  }

  return (baseValue - (toUnit.offset ?? 0)) / toUnit.factor
}

export function parseMeasurementInput(rawValue) {
  const normalised = rawValue.trim().replace(/\s/g, '').replace(',', '.')
  if (normalised === '' || normalised === '-' || normalised === '.') return Number.NaN
  return Number(normalised)
}

export function formatMeasurement(value) {
  if (Number.isNaN(value)) return '—'
  if (!Number.isFinite(value)) return '∞'
  if (Object.is(value, -0) || value === 0) return '0'

  const absolute = Math.abs(value)
  if (absolute >= 1e12 || absolute < 1e-7) {
    return value.toExponential(7).replace(/\.?(0+)e/, 'e')
  }

  return new Intl.NumberFormat('en', {
    maximumSignificantDigits: 7,
    maximumFractionDigits: 10,
    useGrouping: true,
  }).format(value)
}

export function getUnit(category, unitId) {
  return category.units.find((unit) => unit.id === unitId) ?? category.units[0]
}
